// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* eslint-disable max-len */
.order-inputs-container .order-table-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 0.375rem 0.375rem 0 0;
  padding: 1rem 1.5rem;
}
.order-inputs-container .order-table-header h5 {
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
}
.order-inputs-container .order-table-header .table-controls .btn {
  transition: all 0.2s ease;
  border-width: 2px;
  font-weight: 500;
}
.order-inputs-container .order-table-header .table-controls .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.order-inputs-container .order-table-header .table-controls .btn.btn-outline-success {
  border-color: rgba(255, 255, 255, 0.6);
  color: white;
}
.order-inputs-container .order-table-header .table-controls .btn.btn-outline-success:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: white;
}
.order-inputs-container .order-table-header .table-controls .btn.btn-outline-danger {
  border-color: rgba(255, 255, 255, 0.6);
  color: white;
}
.order-inputs-container .order-table-header .table-controls .btn.btn-outline-danger:hover {
  background-color: rgba(220, 53, 69, 0.8);
  border-color: #dc3545;
}
.order-inputs-container .order-no-field {
  background-color: #f8f9fa !important;
  border: 2px solid #e9ecef !important;
  color: #6c757d !important;
  font-weight: 600 !important;
  text-align: center !important;
  cursor: not-allowed !important;
}
.order-inputs-container .order-no-field::placeholder {
  color: #adb5bd !important;
  font-style: italic;
}
.order-inputs-container .order-no-field:focus {
  box-shadow: none !important;
  border-color: #e9ecef !important;
}
.order-inputs-container .form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.order-inputs-container .form-label .currency-unit-info {
  color: #6c757d;
  font-weight: 500;
  font-size: 0.8rem;
  margin-left: 0.5rem;
  opacity: 0.8;
}
.order-inputs-container .form-label::after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5rem;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-bottom: 3px solid #667eea;
  transition: all 0.2s ease;
}
.order-inputs-container .form-control,
.order-inputs-container .form-select {
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}
.order-inputs-container .form-control:focus,
.order-inputs-container .form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}
.order-inputs-container .form-control::placeholder,
.order-inputs-container .form-select::placeholder {
  color: #adb5bd;
  font-style: italic;
  font-size: 0.8rem;
}
.order-inputs-container .form-control.is-invalid,
.order-inputs-container .form-select.is-invalid {
  border-color: #dc3545;
}
.order-inputs-container .form-control.is-invalid:focus,
.order-inputs-container .form-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.order-inputs-container .form-control[type=number] {
  -moz-appearance: textfield;
}
.order-inputs-container .form-control[type=number]::-webkit-outer-spin-button, .order-inputs-container .form-control[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.order-inputs-container .price-input-group {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e0e6ed;
  border-radius: 12px;
  padding: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.order-inputs-container .price-input-group:hover {
  border-color: #c5d2e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.order-inputs-container .price-input-group:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.08), 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.order-inputs-container .price-input-group:focus-within .currency-symbol {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
  transform: scale(1.02);
  box-shadow: 0 3px 8px rgba(102, 126, 234, 0.25);
}
.order-inputs-container .price-input-group.is-invalid {
  border-color: #e74c3c;
  background: #fefbfb;
}
.order-inputs-container .price-input-group.is-invalid:focus-within {
  border-color: #e74c3c;
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.08);
}
.order-inputs-container .price-input-group.is-invalid .currency-symbol {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
}
.order-inputs-container .price-input-group.readonly {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-color: #dee2e6;
  cursor: not-allowed;
}
.order-inputs-container .price-input-group.readonly:hover {
  border-color: #dee2e6;
  transform: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.order-inputs-container .price-input-group.readonly .currency-symbol {
  background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
  color: white;
  opacity: 0.8;
}
.order-inputs-container .price-input-group.readonly .price-whole,
.order-inputs-container .price-input-group.readonly .price-decimal {
  background: transparent;
  cursor: not-allowed;
  color: #6c757d;
  font-weight: 600;
}
.order-inputs-container .price-input-group .currency-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 700;
  font-size: 1.2rem;
  border-radius: 10px;
  margin: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.15);
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
}
.order-inputs-container .price-input-group .currency-symbol::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, transparent 50%);
  pointer-events: none;
}
.order-inputs-container .price-input-group .currency-symbol:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}
.order-inputs-container .price-input-group .currency-symbol:active {
  transform: scale(0.98);
}
.order-inputs-container .price-input-group .currency-symbol:empty::before {
  content: "₺";
}
.order-inputs-container .price-input-group .price-input-section {
  flex: 1 1;
  display: flex;
  align-items: center;
  padding: 0 16px;
  min-height: 50px;
}
.order-inputs-container .price-input-group .price-whole {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  padding: 0;
  text-align: right;
  min-width: 60px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}
.order-inputs-container .price-input-group .price-whole:focus {
  outline: none;
  color: #1a252f;
}
.order-inputs-container .price-input-group .price-whole::placeholder {
  color: #bdc3c7;
  font-weight: 400;
  opacity: 0.7;
}
.order-inputs-container .price-input-group .decimal-separator {
  font-size: 1.4rem;
  font-weight: 300;
  color: #95a5a6;
  margin: 0 8px;
  -webkit-user-select: none;
          user-select: none;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}
.order-inputs-container .price-input-group .price-decimal {
  width: 50px;
  border: none;
  background: transparent;
  font-size: 1.1rem;
  font-weight: 500;
  color: #34495e;
  padding: 0;
  text-align: center;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}
.order-inputs-container .price-input-group .price-decimal:focus {
  outline: none;
  color: #2c3e50;
}
.order-inputs-container .price-input-group .price-decimal::placeholder {
  color: #bdc3c7;
  font-weight: 300;
  opacity: 0.7;
}
.order-inputs-container .btn {
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.order-inputs-container .btn.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}
.order-inputs-container .btn.btn-primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}
.order-inputs-container .btn.btn-primary:disabled {
  background: #adb5bd;
  transform: none;
  box-shadow: none;
}
.order-inputs-container .btn.btn-secondary.btn-outline {
  border: 2px solid #6c757d;
  color: #6c757d;
}
.order-inputs-container .btn.btn-secondary.btn-outline:hover {
  background-color: #6c757d;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);
}
.order-inputs-container .alert {
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
}
.order-inputs-container .alert.alert-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border-left: 4px solid #28a745;
}
.order-inputs-container .alert.alert-danger {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border-left: 4px solid #dc3545;
}
.order-inputs-container .invalid-feedback {
  display: block !important;
  font-size: 0.75rem;
  color: #dc3545;
  margin-top: 0.25rem;
  font-weight: 500;
}
.order-inputs-container .invalid-feedback::before {
  content: "⚠ ";
  margin-right: 0.25rem;
}
.order-inputs-container .card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.order-inputs-container .card .card-header {
  border-bottom: none;
}
.order-inputs-container .card .card-header.order-table-header {
  margin: 0;
  border-radius: 0;
}
.order-inputs-container .card .card-body.p-0 {
  padding: 0 !important;
}
@media (max-width: 768px) {
  .order-inputs-container .table-controls {
    flex-direction: column;
    gap: 0.5rem;
  }
  .order-inputs-container .table-controls .btn {
    width: 100%;
  }
  .order-inputs-container .price-input-group .currency-symbol {
    width: 45px;
    height: 45px;
    font-size: 1.1rem;
  }
  .order-inputs-container .price-input-group .price-input-section {
    padding: 0 12px;
  }
  .order-inputs-container .price-input-group .price-whole {
    font-size: 1.1rem;
    min-width: 50px;
  }
  .order-inputs-container .price-input-group .decimal-separator {
    font-size: 1.3rem;
    margin: 0 6px;
  }
  .order-inputs-container .price-input-group .price-decimal {
    width: 45px;
    font-size: 1rem;
  }
}
@media (max-width: 576px) {
  .order-inputs-container {
    padding: 0.5rem;
  }
  .order-inputs-container .btn {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
  }
  .order-inputs-container .form-control,
  .order-inputs-container .form-select {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
  .order-inputs-container .price-input-group {
    border-radius: 10px;
  }
  .order-inputs-container .price-input-group .currency-symbol {
    width: 40px;
    height: 40px;
    font-size: 1rem;
    border-radius: 8px;
    margin: 1px;
  }
  .order-inputs-container .price-input-group .price-input-section {
    padding: 0 10px;
    min-height: 40px;
  }
  .order-inputs-container .price-input-group .price-whole {
    font-size: 1rem;
    min-width: 40px;
  }
  .order-inputs-container .price-input-group .decimal-separator {
    font-size: 1.2rem;
    margin: 0 4px;
  }
  .order-inputs-container .price-input-group .price-decimal {
    width: 40px;
    font-size: 0.9rem;
  }
}

.currency-modal .modal-dialog {
  max-width: 450px;
}
.currency-modal .currency-modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-bottom: none;
  padding: 1.5rem;
}
.currency-modal .currency-modal-header .modal-title {
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
}
.currency-modal .currency-modal-header .modal-title .modal-currency-icon {
  font-size: 1.3rem;
  margin-right: 0.75rem;
  display: inline-block;
  transform: scale(1.1);
}
.currency-modal .currency-modal-header .btn-close {
  filter: invert(1);
  opacity: 0.8;
}
.currency-modal .currency-modal-header .btn-close:hover {
  opacity: 1;
}
.currency-modal .currency-search-container {
  padding: 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}
.currency-modal .currency-search-container .currency-search-input {
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}
.currency-modal .currency-search-container .currency-search-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  outline: none;
}
.currency-modal .currency-search-container .currency-search-input::placeholder {
  color: #adb5bd;
  font-style: italic;
}
.currency-modal .currency-list-item {
  border: none;
  border-bottom: 1px solid #f0f0f0;
  padding: 0;
  transition: all 0.2s ease;
  cursor: pointer;
  margin: 20px;
}
.currency-modal .currency-list-item:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  transform: translateX(2px);
}
.currency-modal .currency-list-item:active {
  transform: translateX(0px);
}
.currency-modal .currency-list-item:last-child {
  border-bottom: none;
}
.currency-modal .currency-list-item .currency-item-content {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  gap: 1rem;
}
.currency-modal .currency-list-item .currency-item-content .currency-symbol-display {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 700;
  font-size: 1.2rem;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
  transition: all 0.3s ease;
}
.currency-modal .currency-list-item .currency-item-content .currency-info {
  flex: 1 1;
}
.currency-modal .currency-list-item .currency-item-content .currency-info .currency-name {
  font-weight: 600;
  font-size: 0.95rem;
  color: #2c3e50;
  margin-bottom: 0.25rem;
  line-height: 1.2;
}
.currency-modal .currency-list-item .currency-item-content .currency-info .currency-code {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.currency-modal .currency-list-item .currency-item-content .currency-selected-indicator .selected-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #28a745;
  color: white;
  border-radius: 50%;
  font-size: 0.8rem;
  font-weight: 700;
  animation: checkmark-bounce 0.3s ease;
}
.currency-modal .currency-list-item:hover .currency-symbol-display {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
@keyframes checkmark-bounce {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes tooltipFadeIn {
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(-5px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OrderInputs/OrderInputs.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,2BAAA;AAGE;EACE,6DAAA;EACA,YAAA;EACA,oCAAA;EACA,oBAAA;AAAJ;AAEI;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;AAAN;AAIM;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;AAFR;AAIQ;EACE,2BAAA;EACA,yCAAA;AAFV;AAKQ;EACE,sCAAA;EACA,YAAA;AAHV;AAKU;EACE,0CAAA;EACA,mBAAA;AAHZ;AAOQ;EACE,sCAAA;EACA,YAAA;AALV;AAOU;EACE,wCAAA;EACA,qBAAA;AALZ;AAaE;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;AAXJ;AAaI;EACE,yBAAA;EACA,kBAAA;AAXN;AAcI;EACE,2BAAA;EACA,gCAAA;AAZN;AAiBE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAfJ;AAkBI;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAhBN;AAmBI;EACE,WAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,yBAAA;AAjBN;AAqBE;;EAEE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AAnBJ;AAqBI;;EACE,qBAAA;EACA,8CAAA;EACA,2BAAA;AAlBN;AAqBI;;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAlBN;AAqBI;;EACE,qBAAA;AAlBN;AAoBM;;EACE,qBAAA;EACA,4CAAA;AAjBR;AAsBE;EAME,0BAAA;AAzBJ;AAoBI;EAEE,wBAAA;EACA,SAAA;AAnBN;AAyBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AAvBJ;AAyBI;EACE,qBAAA;EACA,yCAAA;AAvBN;AA0BI;EACE,qBAAA;EACA,+EAAA;EACA,2BAAA;AAxBN;AA0BM;EACE,6DAAA;EACA,sBAAA;EACA,+CAAA;AAxBR;AA4BI;EACE,qBAAA;EACA,mBAAA;AA1BN;AA4BM;EACE,qBAAA;EACA,6CAAA;AA1BR;AA6BM;EACE,6DAAA;EACA,YAAA;AA3BR;AA+BI;EACE,6DAAA;EACA,qBAAA;EACA,mBAAA;AA7BN;AA+BM;EACE,qBAAA;EACA,eAAA;EACA,yCAAA;AA7BR;AAgCM;EACE,6DAAA;EACA,YAAA;EACA,YAAA;AA9BR;AAiCM;;EAEE,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA/BR;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,iDAAA;EACA,+CAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAjCN;AAmCM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,iFAAA;EACA,oBAAA;AAjCR;AAoCM;EACE,6DAAA;EACA,sBAAA;EACA,gDAAA;AAlCR;AAqCM;EACE,sBAAA;AAnCR;AAsCM;EACE,YAAA;AApCR;AAwCI;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtCN;AAyCI;EACE,SAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,mEAAA;AAvCN;AAyCM;EACE,aAAA;EACA,cAAA;AAvCR;AA0CM;EACE,cAAA;EACA,gBAAA;EACA,YAAA;AAxCR;AA4CI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;AA1CN;AA6CI;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mEAAA;AA3CN;AA6CM;EACE,aAAA;EACA,cAAA;AA3CR;AA8CM;EACE,cAAA;EACA,gBAAA;EACA,YAAA;AA5CR;AAkDE;EACE,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAhDJ;AAkDI;EACE,6DAAA;EACA,YAAA;AAhDN;AAkDM;EACE,6DAAA;EACA,2BAAA;EACA,+CAAA;AAhDR;AAmDM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAjDR;AAsDM;EACE,yBAAA;EACA,cAAA;AApDR;AAsDQ;EACE,yBAAA;EACA,2BAAA;EACA,+CAAA;AApDV;AA2DE;EACE,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;AAzDJ;AA2DI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAzDN;AA4DI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AA1DN;AA+DE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA7DJ;AA+DI;EACE,aAAA;EACA,qBAAA;AA7DN;AAkEE;EACE,YAAA;EACA,sBAAA;EACA,0CAAA;EACA,gBAAA;AAhEJ;AAkEI;EACE,mBAAA;AAhEN;AAkEM;EACE,SAAA;EACA,gBAAA;AAhER;AAqEM;EACE,qBAAA;AAnER;AAyEE;EACE;IACE,sBAAA;IACA,WAAA;EAvEJ;EAyEI;IACE,WAAA;EAvEN;EA4EI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EA1EN;EA6EI;IACE,eAAA;EA3EN;EA8EI;IACE,iBAAA;IACA,eAAA;EA5EN;EA+EI;IACE,iBAAA;IACA,aAAA;EA7EN;EAgFI;IACE,WAAA;IACA,eAAA;EA9EN;AACF;AAkFE;EAncF;IAocI,eAAA;EA/EF;EAiFE;IACE,oBAAA;IACA,kBAAA;EA/EJ;EAkFE;;IAEE,uBAAA;IACA,iBAAA;EAhFJ;EAmFE;IACE,mBAAA;EAjFJ;EAmFI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;EAjFN;EAoFI;IACE,eAAA;IACA,gBAAA;EAlFN;EAqFI;IACE,eAAA;IACA,eAAA;EAnFN;EAsFI;IACE,iBAAA;IACA,aAAA;EApFN;EAuFI;IACE,WAAA;IACA,iBAAA;EArFN;AACF;;AA4FE;EACE,gBAAA;AAzFJ;AA4FE;EACE,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AA1FJ;AA4FI;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;AA1FN;AA4FM;EACE,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;AA1FR;AA8FI;EACE,iBAAA;EACA,YAAA;AA5FN;AA8FM;EACE,UAAA;AA5FR;AAiGE;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AA/FJ;AAiGI;EACE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AA/FN;AAiGM;EACE,qBAAA;EACA,8CAAA;EACA,aAAA;AA/FR;AAkGM;EACE,cAAA;EACA,kBAAA;AAhGR;AAqGE;EACE,YAAA;EACA,gCAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AAnGJ;AAqGI;EACE,6DAAA;EACA,0BAAA;AAnGN;AAsGI;EACE,0BAAA;AApGN;AAuGI;EACE,mBAAA;AArGN;AAwGI;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;AAtGN;AAwGM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,8CAAA;EACA,yBAAA;AAtGR;AAyGM;EACE,SAAA;AAvGR;AAyGQ;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AAvGV;AA0GQ;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAxGV;AA6GQ;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qCAAA;AA3GV;AAgHI;EACE,sBAAA;EACA,+CAAA;AA9GN;;AAoHA;EACE;IAAO,UAAA;EAhHP;EAiHA;IAAK,UAAA;EA9GL;AACF;AAgHA;EACE;IACE,UAAA;IACA,2BAAA;EA9GF;EAgHA;IACE,UAAA;IACA,wBAAA;EA9GF;AACF;AAiHA;EACE;IACE,UAAA;EA/GF;EAiHA;IACE,YAAA;EA/GF;AACF;AAkHA;EACE;IACE,mBAAA;EAhHF;EAkHA;IACE,qBAAA;EAhHF;EAkHA;IACE,mBAAA;EAhHF;AACF;AAmHA;EACE;IACE,UAAA;IACA,4CAAA;EAjHF;AACF","sourcesContent":["/* eslint-disable max-len */\n.order-inputs-container {\n  // Tablo başlığı\n  .order-table-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border-radius: 0.375rem 0.375rem 0 0;\n    padding: 1rem 1.5rem;\n    \n    h5 {\n      font-weight: 600;\n      font-size: 1.1rem;\n      letter-spacing: 0.5px;\n    }\n    \n    .table-controls {\n      .btn {\n        transition: all 0.2s ease;\n        border-width: 2px;\n        font-weight: 500;\n        \n        &:hover {\n          transform: translateY(-1px);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n        }\n        \n        &.btn-outline-success {\n          border-color: rgba(255, 255, 255, 0.6);\n          color: white;\n          \n          &:hover {\n            background-color: rgba(255, 255, 255, 0.1);\n            border-color: white;\n          }\n        }\n        \n        &.btn-outline-danger {\n          border-color: rgba(255, 255, 255, 0.6);\n          color: white;\n          \n          &:hover {\n            background-color: rgba(220, 53, 69, 0.8);\n            border-color: #dc3545;\n          }\n        }\n      }\n    }\n  }\n\n  // OrderNo field styling\n  .order-no-field {\n    background-color: #f8f9fa !important;\n    border: 2px solid #e9ecef !important;\n    color: #6c757d !important;\n    font-weight: 600 !important;\n    text-align: center !important;\n    cursor: not-allowed !important;\n    \n    &::placeholder {\n      color: #adb5bd !important;\n      font-style: italic;\n    }\n    \n    &:focus {\n      box-shadow: none !important;\n      border-color: #e9ecef !important;\n    }\n  }\n\n  // Form ve input stilleri\n  .form-label {\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n    \n    // Currency and unit symbols styling\n    .currency-unit-info {\n      color: #6c757d;\n      font-weight: 500;\n      font-size: 0.8rem;\n      margin-left: 0.5rem;\n      opacity: 0.8;\n    }\n    \n    &::after {\n      content: '';\n      display: inline-block;\n      width: 0;\n      height: 0;\n      margin-left: 0.5rem;\n      border-left: 3px solid transparent;\n      border-right: 3px solid transparent;\n      border-bottom: 3px solid #667eea;\n      transition: all 0.2s ease;\n    }\n  }\n  \n  .form-control,\n  .form-select {\n    border: 2px solid #e9ecef;\n    border-radius: 0.5rem;\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    transition: all 0.3s ease;\n    \n    &:focus {\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      transform: translateY(-1px);\n    }\n    \n    &::placeholder {\n      color: #adb5bd;\n      font-style: italic;\n      font-size: 0.8rem;\n    }\n    \n    &.is-invalid {\n      border-color: #dc3545;\n      \n      &:focus {\n        border-color: #dc3545;\n        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n      }\n    }\n  }\n  \n  .form-control[type=\"number\"] {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    -moz-appearance: textfield;\n  }\n  \n  // Price Input Group - Professional Currency Design\n  .price-input-group {\n    display: flex;\n    align-items: center;\n    background: #ffffff;\n    border: 1px solid #e0e6ed;\n    border-radius: 12px;\n    padding: 0;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n    \n    &:hover {\n      border-color: #c5d2e0;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    }\n    \n    &:focus-within {\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.08), 0 4px 12px rgba(0, 0, 0, 0.08);\n      transform: translateY(-1px);\n      \n      .currency-symbol {\n        background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n        transform: scale(1.02);\n        box-shadow: 0 3px 8px rgba(102, 126, 234, 0.25);\n      }\n    }\n    \n    &.is-invalid {\n      border-color: #e74c3c;\n      background: #fefbfb;\n      \n      &:focus-within {\n        border-color: #e74c3c;\n        box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.08);\n      }\n      \n      .currency-symbol {\n        background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n        color: white;\n      }\n    }\n    \n    &.readonly {\n      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n      border-color: #dee2e6;\n      cursor: not-allowed;\n      \n      &:hover {\n        border-color: #dee2e6;\n        transform: none;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n      }\n      \n      .currency-symbol {\n        background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);\n        color: white;\n        opacity: 0.8;\n      }\n      \n      .price-whole,\n      .price-decimal {\n        background: transparent;\n        cursor: not-allowed;\n        color: #6c757d;\n        font-weight: 600;\n      }\n    }\n    \n    .currency-symbol {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 50px;\n      height: 50px;\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n      font-weight: 700;\n      font-size: 1.2rem;\n      border-radius: 10px;\n      margin: 2px;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      box-shadow: 0 2px 6px rgba(102, 126, 234, 0.15);\n      flex-shrink: 0;\n      cursor: pointer;\n      position: relative;\n      \n      &::after {\n        content: '';\n        position: absolute;\n        inset: 0;\n        border-radius: inherit;\n        background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%);\n        pointer-events: none;\n      }\n      \n      &:hover {\n        background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n        transform: scale(1.05);\n        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n      }\n      \n      &:active {\n        transform: scale(0.98);\n      }\n      \n      &:empty::before {\n        content: '₺';\n      }\n    }\n    \n    .price-input-section {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      padding: 0 16px;\n      min-height: 50px;\n    }\n    \n    .price-whole {\n      flex: 1;\n      border: none;\n      background: transparent;\n      font-size: 1.2rem;\n      font-weight: 600;\n      color: #2c3e50;\n      padding: 0;\n      text-align: right;\n      min-width: 60px;\n      font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n      \n      &:focus {\n        outline: none;\n        color: #1a252f;\n      }\n      \n      &::placeholder {\n        color: #bdc3c7;\n        font-weight: 400;\n        opacity: 0.7;\n      }\n    }\n    \n    .decimal-separator {\n      font-size: 1.4rem;\n      font-weight: 300;\n      color: #95a5a6;\n      margin: 0 8px;\n      user-select: none;\n      font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n    }\n    \n    .price-decimal {\n      width: 50px;\n      border: none;\n      background: transparent;\n      font-size: 1.1rem;\n      font-weight: 500;\n      color: #34495e;\n      padding: 0;\n      text-align: center;\n      font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n      \n      &:focus {\n        outline: none;\n        color: #2c3e50;\n      }\n      \n      &::placeholder {\n        color: #bdc3c7;\n        font-weight: 300;\n        opacity: 0.7;\n      }\n    }\n  }\n  \n  // Button styling\n  .btn {\n    border-radius: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    font-weight: 600;\n    font-size: 0.875rem;\n    transition: all 0.3s ease;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    \n    &.btn-primary {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border: none;\n      \n      &:hover {\n        background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);\n      }\n      \n      &:disabled {\n        background: #adb5bd;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n    \n    &.btn-secondary {\n      &.btn-outline {\n        border: 2px solid #6c757d;\n        color: #6c757d;\n        \n        &:hover {\n          background-color: #6c757d;\n          transform: translateY(-2px);\n          box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);\n        }\n      }\n    }\n  }\n  \n  // Alert styling\n  .alert {\n    border-radius: 0.5rem;\n    border: none;\n    padding: 1rem 1.5rem;\n    margin-bottom: 1.5rem;\n    \n    &.alert-success {\n      background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n      color: #155724;\n      border-left: 4px solid #28a745;\n    }\n    \n    &.alert-danger {\n      background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n      color: #721c24;\n      border-left: 4px solid #dc3545;\n    }\n  }\n  \n  // Invalid feedback styling\n  .invalid-feedback {\n    display: block !important;\n    font-size: 0.75rem;\n    color: #dc3545;\n    margin-top: 0.25rem;\n    font-weight: 500;\n    \n    &::before {\n      content: '⚠ ';\n      margin-right: 0.25rem;\n    }\n  }\n  \n  // Card styling\n  .card {\n    border: none;\n    border-radius: 0.75rem;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    \n    .card-header {\n      border-bottom: none;\n      \n      &.order-table-header {\n        margin: 0;\n        border-radius: 0;\n      }\n    }\n    \n    .card-body {\n      &.p-0 {\n        padding: 0 !important;\n      }\n    }\n  }\n  \n  // Responsive adjustments\n  @media (max-width: 768px) {\n    .table-controls {\n      flex-direction: column;\n      gap: 0.5rem;\n      \n      .btn {\n        width: 100%;\n      }\n    }\n    \n    .price-input-group {\n      .currency-symbol {\n        width: 45px;\n        height: 45px;\n        font-size: 1.1rem;\n      }\n      \n      .price-input-section {\n        padding: 0 12px;\n      }\n      \n      .price-whole {\n        font-size: 1.1rem;\n        min-width: 50px;\n      }\n      \n      .decimal-separator {\n        font-size: 1.3rem;\n        margin: 0 6px;\n      }\n      \n      .price-decimal {\n        width: 45px;\n        font-size: 1rem;\n      }\n    }\n  }\n  \n  @media (max-width: 576px) {\n    padding: 0.5rem;\n    \n    .btn {\n      padding: 0.5rem 1rem;\n      font-size: 0.75rem;\n    }\n    \n    .form-control,\n    .form-select {\n      padding: 0.5rem 0.75rem;\n      font-size: 0.8rem;\n    }\n    \n    .price-input-group {\n      border-radius: 10px;\n      \n      .currency-symbol {\n        width: 40px;\n        height: 40px;\n        font-size: 1rem;\n        border-radius: 8px;\n        margin: 1px;\n      }\n      \n      .price-input-section {\n        padding: 0 10px;\n        min-height: 40px;\n      }\n      \n      .price-whole {\n        font-size: 1rem;\n        min-width: 40px;\n      }\n      \n      .decimal-separator {\n        font-size: 1.2rem;\n        margin: 0 4px;\n      }\n      \n      .price-decimal {\n        width: 40px;\n        font-size: 0.9rem;\n      }\n    }\n  }\n}\n\n// Currency Modal Styling\n.currency-modal {\n  .modal-dialog {\n    max-width: 450px;\n  }\n  \n  .currency-modal-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border-bottom: none;\n    padding: 1.5rem;\n    \n    .modal-title {\n      font-weight: 600;\n      font-size: 1.1rem;\n      letter-spacing: 0.5px;\n      \n      .modal-currency-icon {\n        font-size: 1.3rem;\n        margin-right: 0.75rem;\n        display: inline-block;\n        transform: scale(1.1);\n      }\n    }\n    \n    .btn-close {\n      filter: invert(1);\n      opacity: 0.8;\n      \n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n  \n  .currency-search-container {\n    padding: 1rem;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n    \n    .currency-search-input {\n      border: 1px solid #dee2e6;\n      border-radius: 0.5rem;\n      padding: 0.75rem 1rem;\n      font-size: 0.875rem;\n      transition: all 0.3s ease;\n      \n      &:focus {\n        border-color: #667eea;\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n        outline: none;\n      }\n      \n      &::placeholder {\n        color: #adb5bd;\n        font-style: italic;\n      }\n    }\n  }\n  \n  .currency-list-item {\n    border: none;\n    border-bottom: 1px solid #f0f0f0;\n    padding: 0;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    margin: 20px;\n    \n    &:hover {\n      background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n      transform: translateX(2px);\n    }\n    \n    &:active {\n      transform: translateX(0px);\n    }\n    \n    &:last-child {\n      border-bottom: none;\n    }\n    \n    .currency-item-content {\n      display: flex;\n      align-items: center;\n      padding: 1rem 1.5rem;\n      gap: 1rem;\n      \n      .currency-symbol-display {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 45px;\n        height: 45px;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n        font-weight: 700;\n        font-size: 1.2rem;\n        border-radius: 50%;\n        flex-shrink: 0;\n        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\n        transition: all 0.3s ease;\n      }\n      \n      .currency-info {\n        flex: 1;\n        \n        .currency-name {\n          font-weight: 600;\n          font-size: 0.95rem;\n          color: #2c3e50;\n          margin-bottom: 0.25rem;\n          line-height: 1.2;\n        }\n        \n        .currency-code {\n          font-size: 0.8rem;\n          color: #6c757d;\n          font-weight: 500;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n        }\n      }\n      \n      .currency-selected-indicator {\n        .selected-check {\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          width: 24px;\n          height: 24px;\n          background: #28a745;\n          color: white;\n          border-radius: 50%;\n          font-size: 0.8rem;\n          font-weight: 700;\n          animation: checkmark-bounce 0.3s ease;\n        }\n      }\n    }\n    \n    &:hover .currency-symbol-display {\n      transform: scale(1.05);\n      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n    }\n  }\n}\n\n// Keyframe animations\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n@keyframes checkmark-bounce {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes tooltipFadeIn {\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(-5px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
